import commonapi from '@lib/api/common.js'
// eslint-disable-next-line no-undef
const qiniu = require('qiniu-js')
const COS = require('cos-js-sdk-v5')
import JSEncrypt from 'jsencrypt-ext'

/*
 * 生成唯一的uuid
 */
const uuid = () => {
  const s4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  return [s4(), s4(), s4(), s4()].join('')
}

// // 上次文件
// const UploadFile = ({ file, name, success, fail }) => {
//   const observer = {
//     next(res) {},
//     error(err) {
//       if (fail && typeof fail === 'function') {
//         fail(err)
//       }
//     },
//     complete(res) {
//       if (success && typeof success === 'function') {
//         success({
//           fileName: res.key,
//           url: `https://cdn.qupeiyin.cn/${res.key}`
//         })
//       }
//     }
//   }
//   const ext = file.name.substr(file.name.lastIndexOf('.'))
//   const key = name || uuid() + ext
//   utilsApi.GetQiniuToken().then(result => {
//     const fileToken = result.data.file
//     qiniu.upload(file, key, fileToken).subscribe(observer)
//   })
// }

// // 上次图片
// const UploadPic = ({ file, name, success, fail }) => {
//   const observer = {
//     next(res) {},
//     error(err) {
//       if (fail && typeof fail === 'function') {
//         fail(err)
//       }
//     },
//     complete(res) {
//       if (success && typeof success === 'function') {
//         success({
//           fileName: res.key,
//           url: `https://peiyinimg.qupeiyin.cn/${res.key}`
//         })
//       }
//     }
//   }
//   const ext = file.name.substr(file.name.lastIndexOf('.'))
//   const key = name || uuid() + ext
//   utilsApi.GetQiniuToken().then(result => {
//     const picToken = result.data.pic
//     qiniu.upload(file, key, picToken).subscribe(observer)
//   })
// }

// 当前使用的云服务类型（'qiniu' 或 'tencent'）
const CURRENT_CLOUD_SERVICE = 'tencent' // 默认使用七牛云
const UPLOAD_TYPE = {
  PIC: 'pic',
  VIDEO: 'mp4',
  FILE: 'file'
}
// 七牛云上传实现
const uploadQiniu = {
  _uploadQiniuInternal: ({ file, name, success, fail, isexamine = true, type }) => {
    commonapi.GetQiniuToken().then((result) => {
      let fileToken = result.data.file

      let key
      let ext = file.name.substr(file.name.lastIndexOf('.'))
      if (type == UPLOAD_TYPE.FILE) {
        fileToken = result.data.file
        key = `${new Date().format('yyyyMMdd')}/${name || uuid() + ext}`
      } else if (type == UPLOAD_TYPE.PIC) {
        fileToken = result.data.pic
        key = `${isexamine == true ? '' : 'dubbing/'}${new Date().format('yyyyMMdd')}/${name || uuid() + ext
          }`
      } else if (type == UPLOAD_TYPE.VIDEO) {
        fileToken = result.data.mp4
        ext = '.mp4'
        key = `${new Date().format('yyyyMMdd')}/${name || uuid() + ext
          }`
      }

      const observer = {
        next(res) { },
        error(err) {
          if (fail && typeof fail === 'function') {
            fail(err)
          }
        },
        complete(res) {
          let urlPrefix = 'https://cdn.qupeiyin.cn/'
          if (type === UPLOAD_TYPE.PIC) {
            urlPrefix = 'https://img.qupeiyin.cn/'
          }
          if (success && typeof success === 'function') {
            success({
              fileName: res.key,
              url: `${urlPrefix}${res.key}`
            })
          }
        }
      }

      qiniu.upload(file, key, fileToken).subscribe(observer)
    }).catch(err => {
      if (fail && typeof fail === 'function') {
        fail(err)
      }
    })
  },

  UploadFile: ({ file, name, success, fail }) => {
    uploadQiniu._uploadQiniuInternal({ file, name, success, fail, type: UPLOAD_TYPE.FILE })
  },

  UploadVideo: ({ file, name, success, fail }) => {
    uploadQiniu._uploadQiniuInternal({ file, name, success, fail, type: UPLOAD_TYPE.VIDEO })
  },

  UploadPic: ({ isexamine = true, file, name, success, fail }) => {
    uploadQiniu._uploadQiniuInternal({ file, name, success, fail, isexamine, type: UPLOAD_TYPE.PIC })
  }
}

// 腾讯云上传实现
const cosDecrypt = (encryptedData) => {
  const decrypt = new JSEncrypt()
  decrypt.setPrivateKey(`-----BEGIN RSA PRIVATE KEY-----
    MIICXgIBAAKBgQDhjlVf4D1H4EtnrMiZMP4DMDG3+quVXbvmLm29DDePrhkXAuZ+
    UcDEUCgj8mkKOZPHTGbRaS3N7J1vhLiL+0MfGNcD9CTAoIIGAPY4chQnBjLgSuP0
    3RdK5D7zRkjBE5uX1B/v9Sq/3tlGRUOAKJwduJRlwUtgh9yWlbY/TBUeUwIDAQAB
    AoGBAKJWDpwyh+hzRdIYSUf4OtmQljgT8epOzC2evNyTLmn6o5QsQjgoHtUr27gD
    gBYb2oBWPKn7STwsUCMzIp+c93DQCvuONwO6NEZQKtTzG9KnE+WHbAzwLXuctRjO
    63TA3GyxXoubjCp6r/IIC6roLehuI4l4AMZvOUyOauy7gYwBAkEA+ZbolO5Y+i4p
    C9rJ9uxifc+cVGEbv/GZpA7e9rcp8TeNzl8BollDt+dQtH0naHFg5FuS81VvcrIY
    oXGsEzPeuQJBAOdZZpxrc+MocOf9AqOH9BrDERnYiLjKy5gmwfdRT1a/fk+t18cN
    i2YFKxn9/oEpQg+N+IREGtoeApoAhR6Tv2sCQQDEqxX/7MQt9tufHLqSGHgPfN1J
    W++a0sxnCtTEAVZKXaUe3ZwTClWi/uGIJyo7UUOxDTuBBGw6K33fEQwvYWr5AkBk
    1gWwhfFEAHt90jyVNIvEImPQxR2KlfG5hqMifhE7uUl/x0D2pMOumvAXayrD90yw
    5Ot+EwU1LsFpiHJ9Sl6zAkEApYeWk3KY8faUN35qRvGxRRMX/NcuHRu5MoDOw4Ry
    mtr7lBFI+dtM+CloP3aZObqjB6Lrnkxbwe6Wi3Q7fyTM8Q==
    -----END RSA PRIVATE KEY-----`)
  try {
    const decrypted = decrypt.decrypt(encryptedData)
    return decrypted && decrypted !== '' ? JSON.parse(decrypted) : null
  } catch (error) {
    console.error('解密失败:', error)
    return null
  }
}

const uploadTencent = {
  _commonUploadTencent: ({ file, name, success, fail, isexamine = true, type }) => {
    commonapi.TxCosToken(type).then((result) => {
      const data = cosDecrypt(result.encryptData)
      const cosToken = data.cosToken
      const cos = new COS({
        SecretId: cosToken.tmpSecretId,
        SecretKey: cosToken.tmpSecretKey,
        SecurityToken: cosToken.sessionToken,
        StartTime: data.now_time,
        ExpiredTime: cosToken.expiredTime
      })

      let prefix = ''
      if (isexamine == true && type == UPLOAD_TYPE.PIC) {
        prefix = 'dubbing/'
      }

      const ext = type == UPLOAD_TYPE.VIDEO ? '.mp4' : file.name.substr(file.name.lastIndexOf('.'))
      const key = `${cosToken.prefix && cosToken.prefix.length > 0 ? cosToken.prefix[0] : ''}${prefix}${new Date().format('yyyyMMdd')}/${name || uuid() + ext}`

      cos.uploadFile({
        Bucket: cosToken.bucket,
        Region: 'ap-nanjing', // 根据你的实际地域修改
        Key: key,
        Body: file,
        onProgress: function (progressData) {
          // 可以在这里处理上传进度，如果需要的话
        }
      }, function (err, data) {
        if (err) {
          if (fail && typeof fail === 'function') {
            fail(err)
          }
        } else {
          if (success && typeof success === 'function') {
            success({
              fileName: key,
              url: `${cosToken.domain}/${key}`
            })
          }
        }
      })
    }).catch(err => {
      if (fail && typeof fail === 'function') {
        fail(err)
      }
    })
  },

  UploadFile: ({ file, name, success, fail }) => {
    uploadTencent._commonUploadTencent({ file, name, success, fail, type: UPLOAD_TYPE.FILE })
  },

  UploadVideo: ({ file, name, success, fail }) => {
    uploadTencent._commonUploadTencent({ file, name, success, fail, type: UPLOAD_TYPE.VIDEO })
  },

  UploadPic: ({ isexamine = true, file, name, success, fail }) => {
    uploadTencent._commonUploadTencent({ file, name, success, fail, isexamine, type: UPLOAD_TYPE.PIC })
  }
}

// 统一的上传接口
const UploadFile = ({ file, name, success, fail, serverType = CURRENT_CLOUD_SERVICE }) => {
  if (serverType === 'qiniu' && typeof uploadQiniu !== 'undefined') {
    uploadQiniu.UploadFile({ file, name, success, fail })
  } else if (serverType === 'tencent' && typeof uploadTencent !== 'undefined') {
    uploadTencent.UploadFile({ file, name, success, fail })
  } else {
    console.error('No cloud service available')
    if (fail) fail(new Error('No cloud service available'))
  }
}

const UploadVideo = ({ file, name, success, fail, serverType = CURRENT_CLOUD_SERVICE }) => {
  if (serverType === 'qiniu' && typeof uploadQiniu !== 'undefined') {
    uploadQiniu.UploadVideo({ file, name, success, fail })
  } else if (serverType === 'tencent' && typeof uploadTencent !== 'undefined') {
    uploadTencent.UploadVideo({ file, name, success, fail })
  } else {
    console.error('No cloud service available')
    if (fail) fail(new Error('No cloud service available'))
  }
}

const UploadPic = ({ isexamine = true, file, name, success, fail, serverType = CURRENT_CLOUD_SERVICE }) => {
  if (serverType === 'qiniu' && typeof uploadQiniu !== 'undefined') {
    uploadQiniu.UploadPic({ isexamine, file, name, success, fail })
  } else if (serverType === 'tencent' && typeof uploadTencent !== 'undefined') {
    uploadTencent.UploadPic({ isexamine, file, name, success, fail })
  } else {
    console.error('No cloud service available')
    if (fail) fail(new Error('No cloud service available'))
  }
}

export default {
  UploadFile,
  UploadPic,
  UploadVideo
}
